import { DataRuleDefinition, FieldRule } from '@msdk/definitions'

export function invisibleFieldsToDataRules(fields: string[]): DataRuleDefinition[] {
  const result: DataRuleDefinition[] = []
  fields.forEach((f) => {
    const fRule: FieldRule = {
      clearOnInvisible: false,
      field: f,
      mandatory: false,
      readOnly: false,
      visible: false,
      ruleType: 'FieldRule',
      msgCode: '',
    }
    const rule: DataRuleDefinition = {
      condition: 'true',
      fieldRules: [fRule],
      type: 'Rule',
    }
    result.push(rule)
  })
  return result
}

export function nonWritableFieldsToDataRules(fields: string[]): DataRuleDefinition[] {
  const result: DataRuleDefinition[] = []
  fields.forEach((f) => {
    const fRule: FieldRule = {
      clearOnInvisible: false,
      field: f,
      mandatory: false,
      readOnly: true,
      ruleType: 'FieldRule',
    }
    const rule: DataRuleDefinition = {
      condition: 'true',
      fieldRules: [fRule],
      type: 'Rule',
    }
    result.push(rule)
  })
  return result
}
